import { gql } from "@apollo/client";

export const GET_BADGE = gql`
  query {
    badge
  }
`;
